export const SPRIG_PATHS = [
  "M200 0 C 170 80, 120 150, 60 290",
  "M180 60 q -30 4 -44 26 q 30 -2 44 -26z",
  "M160 105 q 28 6 40 30 q -28 -4 -40 -30z",
  "M138 150 q -30 2 -46 24 q 30 0 46 -24z",
  "M116 195 q 26 8 36 32 q -26 -6 -36 -32z",
];

/** Ramita decorativa de marca. El contenedor debe tener `relative isolate` y recorte horizontal. */
const BotanicalSprig = ({ className = "" }: { className?: string }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 220 300"
    width={200}
    height={260}
    fill="none"
    stroke="hsl(var(--primary))"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`pointer-events-none absolute -right-10 top-0 -z-10 select-none opacity-45 dark:opacity-30 ${className}`}
  >
    <path d="M200 0 C 170 80, 120 150, 60 290" />
    <path d="M180 60 q -30 4 -44 26 q 30 -2 44 -26z" />
    <path d="M160 105 q 28 6 40 30 q -28 -4 -40 -30z" />
    <path d="M138 150 q -30 2 -46 24 q 30 0 46 -24z" />
    <path d="M116 195 q 26 8 36 32 q -26 -6 -36 -32z" />
  </svg>
);

export default BotanicalSprig;
